<template>
  <Teleport to="body">
    <div v-if="props.visible" v-loading="placingOrder" element-loading-text="LOADING..." element-loading-background="rgba(255, 255, 255, 0.6)">
      <div class="dialog-mask"></div>
      <div class="release-task-dialog">
        <!-- Loading 遮罩层 -->
        <div v-if="isLoading" class="loading-overlay">
          <div class="loading-spinner"></div>
        </div>
        <!-- 右上角关闭按钮 -->
        <button class="close-btn" @click="handleClose" aria-label="关闭">&times;</button>
        <div class="dialog-main">
          <!-- 左侧：进度条、步骤、提示 -->
          <div class="dialog-left">
            <div class="dialog-header">
              <div class="progress-bar">
                <div class="progress-line"></div>
                <div class="progress" :style="{ width: progressWidth }"></div>
                <div v-for="n in 4" :key="n" class="progress-dot" :class="{ active: step >= n }"
                  :style="{ left: (n - 1) * 25 + '%' }"></div>
                <div class="progress-label" style="left: 0">{{ $t('releaseTask.progressDesc') }}</div>
                <div class="progress-label" style="left: 25%">{{ $t('releaseTask.progressBudget') }}</div>
                <div class="progress-label" style="left: 50%">{{$t('releaseTask.progressPay')}}</div>
                <div class="progress-label" style="left: 75%">{{ $t('releaseTask.progressSuccess') }}</div>
              </div>
            </div>
            <div class="progress-tip-center">
              <div>
                <div style="font-size:24px;font-weight:bold;color:#333;margin-bottom:8px;">
                  {{ $t('releaseTask.pleaseDescribe') }}
                </div>
                <div>
                  {{ $t('releaseTask.descTip') }}
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-right">

            <div class="dialog-body">
              <template v-if="step === 1">
                <div class="desc-short">
                  <input v-model="shortDesc" maxlength="20" :placeholder="$t('releaseTask.shortDescPlaceholder')" />
                </div>
                <!-- 新增红色提示 -->
                <div class="desc-type-tip">
                  {{ $t('releaseTask.selectTypeTip') }}
                </div>
                <!-- 新增重建/新建单选 -->
                <div class="desc-radio-group">
                  <label class="desc-radio">
                    <input type="radio" value="rebuild" v-model="descOption" />
                    {{ $t('releaseTask.rebuild') }}
                  </label>
                  <label class="desc-radio">
                    <input type="radio" value="create" v-model="descOption" />
                    {{ $t('releaseTask.createNew') }}
                  </label>
                </div>
                <!-- 标签选择区域，只有选择了重建/新建才显示 -->
                <div v-if="descOption" class="tag-section">
                  <div class="tag-group" style="flex-wrap:nowrap;">
                    <div class="tags">
                      <span v-for="tag in tagList" :key="tag.name" class="tag"
                        :class="{ selected: selectedTags.includes(tag.name) }" @click="toggleTag(tag.name)">
                        {{ tag.label }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="desc-detail">
                  <!-- 富文本编辑器容器 -->
                  <div class="rich-text-editor">
                    <!-- 富文本工具栏 -->
                    <div class="rich-text-toolbar">
                      <button type="button" class="toolbar-btn" @click="formatText('bold')" title="粗体">
                        <strong>B</strong>
                      </button>
                      <button type="button" class="toolbar-btn" @click="formatText('italic')" title="斜体">
                        <em>/</em>
                      </button>
                      <button type="button" class="toolbar-btn" @click="formatText('underline')" title="下划线">
                        <u>U</u>
                      </button>
   
                    </div>
                    <!-- 可编辑富文本区域 -->
                    <div ref="editableDiv" contenteditable="true" class="rich-text-content" @input="onDetailDescInput"
                      @paste="onPaste" @keydown="onKeyDown"
                      :placeholder="$t('releaseTask.detailDescPlaceholder')"></div>
                  </div>
                  
                  <!-- 标签显示区域（如果需要） -->
                  <div v-if="selectedTags.length > 0" class="tags-display" 
                    style="margin-top:10px;padding:10px;border:1px solid #eee;border-radius:4px;">
                    <template v-for="tag in selectedTags" :key="tag">
                      <span class="tag-in-desc" contenteditable="false">
                        {{ tagList.find(t => t.name === tag)?.label || tag }}：
                        <div class="tag-input-div" contenteditable="true"
                          :placeholder="tagList.find(t => t.name === tag)?.placeholder || '请输入内容'"
                          @input="e => handleTagDivInput(tag, e)"
                          style="display:inline-block;min-width:200px;max-width:300px;border:none;background:transparent;outline:none;word-break:break-all;padding:0 4px;">
                        </div>
                        <span @click="removeTag(tag)" style="margin-left:4px;cursor:pointer;color:#f00;">×</span>
                      </span>
                    </template>
                  </div>
                </div>
                <div class="upload-section">
                  <input type="file" ref="fileInput" style="display:none" multiple 
                    accept="image/*,.pdf, .doc,.docx" 
                    @change="handleFileUpload" />
                  <!-- 上传按钮 -->
                  <button class="upload-btn" @click="triggerFileInput">
                    {{ descOption === 'create' ? $t('releaseTask.uploadDrawing') : $t('releaseTask.uploadFile') }}
                  </button>
                  
                  <!-- 上传提示 -->
                    <div class="upload-tip">
                    {{ $t('releaseTask.uploadTenderImage') }}
                  </div>
                  
                  <!-- 文件列表显示 -->
                  <div v-if="uploadedFiles.length > 0" class="uploaded-files">
                    <div class="files-header">
                      <span class="files-count">{{ $t('releaseTask.selectedFiles', { count: uploadedFiles.length }) }}</span>
                      <button class="clear-all-btn" @click="clearAllFiles">{{ $t('releaseTask.clearAll') }}</button>
                    </div>
                    <div class="file-list">
                      <div v-for="(file, index) in uploadedFiles" :key="index" class="file-item">
                        <!-- 图片预览 -->
                        <div class="file-preview">
                          <img 
                            v-if="uploadedFileUrls[index]" 
                            :src="uploadedFileUrls[index]" 
                            :alt="file.name"
                            class="preview-image"
                            @error="handleImageError"
                          />
                          <div v-else class="preview-placeholder">
                            <span class="preview-icon">📷</span>
                          </div>
                        </div>
                        <!-- 文件信息 -->
                        <div class="file-info">
                          <span class="file-size">{{ formatFileSize(file.size) }}</span>
                          <span v-if="uploadingFiles.has(index)" class="upload-status uploading">上传中...</span>
                          <span v-else-if="uploadedFileUrls[index]" class="upload-status success">已上传</span>
                          <span v-else class="upload-status failed">上传失败</span>
                        </div>
                        <button class="remove-file-btn" @click="removeFile(index)" :disabled="uploadingFiles.has(index)">×</button>
                      </div>
                    </div>
                  </div>
                  
                  <!-- 新建项目时显示红色提示 -->
                  <div v-if="descOption === 'create'" class="desc-type-tip">
                    {{ $t('releaseTask.pleaseUploadDrawing') }}
                  </div>
                </div>
              </template>
              <template v-else-if="step === 2">
                <div class="budget-section">
                  <label>
                    {{ $t('releaseTask.budget') }}<span class="required">*</span>
                    <span style="color:#fb6e01;font-size:12px;margin-left:8px;">
                      ({{ $t('releaseTask.feeTip') }})
                    </span>
                  </label>
                  <div>
                    <input v-model="budget" type="number" inputmode="numeric" min="0"
                      :placeholder="$t('releaseTask.budgetPlaceholder')" />
                  </div>
                </div>
                <div class="deadline-section">
                  <label>
                    {{ $t('releaseTask.bidDeadline') }}<span class="required">*</span>
                  </label>
                  <div>
                    <input v-model="bidDeadline" type="datetime-local" 
                      :placeholder="$t('releaseTask.bidDeadlinePlaceholder')" style="width:100%;" />
                  </div>
                </div>
                <div class="phone-section">
                  <label>
                    {{ $t('releaseTask.phoneContact') }}<span class="required">*</span>
                  </label>
                  <div>
                    <input v-model="phone" type="number" inputmode="numeric" maxlength="11"
                      :placeholder="$t('releaseTask.phonePlaceholder')" style="width:100%;" />
                  </div>
                </div>
                <div class="publisher-section">
                  <label>
                    {{ $t('releaseTask.publisher') }}<span class="required">*</span>
                  </label>
                  <div>
                    <input v-model="publisher" type="text" maxlength="50"
                      :placeholder="$t('releaseTask.publisherPlaceholder')" style="width:100%;" />
                  </div>
                </div>
              </template>
              <template v-else-if="step === 3">
                <div class="payment-section">
                  <label>
                    {{ $t('releaseTask.confirmTitle') }}<span class="required">*</span>
                  </label>
                  <div class="confirm-dialog">
                    <div class="confirm-title">{{ $t('releaseTask.confirmTitle1') }}</div>
                    <div class="confirm-content">
                      <div>{{ $t('releaseTask.confirmBudget') }}<b style="color:#fb6e01">${{ budget }}</b></div>
                      <div>{{ $t('releaseTask.confirmBidDeadline') }}<b style="color:#fb6e01;">{{ bidDeadline }}</b></div>
                      <div>{{ $t('releaseTask.confirmPhone') }}<b style="color:#fb6e01">{{ phone }}</b></div>
                      <div>{{ $t('releaseTask.confirmPublisher') }}<b style="color:#fb6e01">{{ publisher }}</b></div>
                      <!-- <div style="margin-top:12px;color:#fb6e01;font-size:15px;">
                        {{ $t('releaseTask.confirmFeeTip') }}
                      </div> -->
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="step === 4">
                <div class="success-tip">
                  {{ $t('releaseTask.successTip') }}
                </div>
                <div class="publish-summary">
                  <div class="summary-title">{{ $t('releaseTask.summaryTitle') }}</div>
                  <div class="summary-item">
                    <b>{{ $t('releaseTask.projectType') || '类型' }}</b>
                    {{
                      descOption === 'rebuild'
                        ? $t('releaseTask.rebuild')
                        : descOption === 'create'
                          ? $t('releaseTask.createNew')
                          : ''
                    }}
                  </div>
                  <div class="summary-item"><b>{{ $t('releaseTask.oneSentence') }}</b>{{ shortDesc }}</div>
                  <div class="summary-item"><b>{{ $t('releaseTask.detailDesc') }}</b>{{ detailDesc }}</div>
                  <div class="summary-item"><b>{{ $t('releaseTask.tags') }}</b>
                    <span v-for="tag in selectedTags" :key="tag" style="margin-right:12px;">
                      {{ tagList.find(t => t.name === tag)?.label || tag }}：{{ tagInputs[tag] }}
                    </span>
                  </div>
                  <div class="summary-item"><b>{{ $t('releaseTask.budget') }}</b>${{ budget }}</div>
                  <div class="summary-item"><b>{{ $t('releaseTask.bidDeadline') }}</b>{{ bidDeadline }}</div>
                  <div class="summary-item"><b>{{ $t('releaseTask.confirmPhone') }}</b>{{ phone }}</div>
                  <div class="summary-item"><b>{{ $t('releaseTask.confirmPublisher') }}</b>{{ publisher }}</div>
                </div>
              </template>
            </div>
            <div class="dialog-footer">
              <template v-if="step === 4">
                <button class="next-btn" @click="handleClose">{{ $t('releaseTask.finish') }}</button>
              </template>
              <template v-else>
                <button class="prev-btn" @click="prevStep" :disabled="step === 1">{{ $t('releaseTask.prev') }}</button>
                <button class="next-btn" @click="nextStep">{{ $t('releaseTask.next') }}</button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
  <Teleport to="body">
    <div v-if="showConfirm" class="confirm-mask">
      <div class="confirm-dialog">
        <div class="confirm-title">{{ $t('releaseTask.confirmTitle1') }}</div>
        <div class="confirm-content">
          <div>{{ $t('releaseTask.confirmBudget') }}<b style="color:#fb6e01">${{ budget }}</b></div>
          <div>{{ $t('releaseTask.confirmBidDeadline') }}<b style="color:#fb6e01;">{{ bidDeadline }}</b></div>
          <div>{{ $t('releaseTask.confirmPhone') }}<b style="color:#fb6e01">{{ phone }}</b></div>
          <div>{{ $t('releaseTask.confirmPublisher') }}<b style="color:#fb6e01">{{ publisher }}</b></div>
          <div style="margin-top:12px;color:#fb6e01;font-size:15px;">
            {{ $t('releaseTask.confirmFeeTip') }}
          </div>
        </div>
        <div class="confirm-actions">
          <button @click="cancelConfirm" class="confirm-cancel" :disabled="isLoading">{{ $t('releaseTask.cancel') }}</button>
          <button @click="confirmInfo" class="confirm-ok" :disabled="isLoading">
            {{ isLoading ? $t('releaseTask.submitting') : $t('releaseTask.confirm') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>

    <!-- 支付弹窗 -->
  <el-dialog
    v-model="showStripeForm"
    :title="t('cart.paymentMethod')"
    :width="paymentDialogWidth"
    :close-on-click-modal="false"
    :show-close="false"
    center
    class="payment-dialog"
  >
    <div id="payment-element">
      <!-- Stripe 支付元素将在这里渲染 -->
    </div>
    <div id="payment-message" class="error-message"></div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="cancelPayment" class="btnhonver">{{t('cart.cancel')}}</el-button>
        <el-button 
          type="primary" 
          :loading="processingPayment"
          @click="handlePaymentSubmit"
          class="btnorange"
        >
          {{t('cart.pay')}} $0
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, computed, nextTick, watch, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { createTender } from '@/api/tender';
import { filesUpload } from '@/api/filesUpload';
import { ElMessage } from 'element-plus';
import { orderSubmit } from '@/api/coupons';
import { loadStripe } from '@stripe/stripe-js';



const { t } = useI18n()
const router = useRouter()
const descOption = ref(''); // 'rebuild' 或 'create'

const props = defineProps<{ visible: boolean }>() // 新增
const emit = defineEmits(['close'])

const step = ref(1)
const shortDesc = ref('')
const detailDesc = ref('')
function onDetailDescInput(e: Event) {
  const el = e.target as HTMLElement;
  // 获取纯文本内容用于验证
  const textContent = el.innerText || '';
  // 获取HTML内容用于保存
  const htmlContent = el.innerHTML || '';
  
  if (!textContent.trim() && (htmlContent === '<br>' || htmlContent === '')) {
    el.innerHTML = '';
    detailDesc.value = '';
  } else {
    // 保存HTML内容，这样可以保留格式
    detailDesc.value = htmlContent;
  }
}

// 富文本编辑器相关方法
function formatText(command: string) {
  document.execCommand(command, false, '')
  editableDiv.value?.focus()
}

function onPaste(e: ClipboardEvent) {
  e.preventDefault()
  const text = e.clipboardData?.getData('text/plain') || ''
  document.execCommand('insertText', false, text)
}

function onKeyDown(e: KeyboardEvent) {
  // 支持常用快捷键
  if (e.ctrlKey || e.metaKey) {
    switch (e.key) {
      case 'b':
        e.preventDefault()
        formatText('bold')
        break
      case 'i':
        e.preventDefault()
        formatText('italic')
        break
      case 'u':
        e.preventDefault()
        formatText('underline')
        break
    }
  }
}
const fileName = ref('')
const uploadedFiles = ref<File[]>([]) // 新增：存储上传的文件数组
const uploadedFileUrls = ref<string[]>([]) // 新增：存储上传成功后的文件URL
const uploadingFiles = ref<Set<number>>(new Set()) // 新增：正在上传的文件索引
const budget = ref(0)
const phone = ref('')
const publisher = ref('')
// 设置默认截止时间为24小时后
const getDefaultDeadline = () => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(18, 0, 0, 0) // 设置默认时间为18:00
  return tomorrow.toISOString().slice(0, 16) // 格式化为 datetime-local 所需的格式
}
const bidDeadline = ref(getDefaultDeadline()) // 招标截止时间
const showConfirm = ref(false)
const isLoading = ref(false)
const selectedTags = ref<string[]>([])

// 进度条宽度
const progressWidth = computed(() => {
  if (step.value === 1) return '25%';
  if (step.value === 2) return '50%';
  if (step.value === 3) return '75%';
  if (step.value === 4) return '100%';
  return '0%';
});

// 文件上传处理
const fileInput = ref<HTMLInputElement | null>(null)
function triggerFileInput() {
  fileInput.value?.click()
}
async function handleFileUpload(event: Event) {
  const input = event.target as HTMLInputElement
  if (input.files && input.files.length > 0) {
    // 将FileList转换为数组
    const newFiles = Array.from(input.files)
    const startIndex = uploadedFiles.value.length
    
    // 添加到文件数组
    uploadedFiles.value = [...uploadedFiles.value, ...newFiles]
    
    console.log('选择的文件：', newFiles)
    console.log('总文件数量：', uploadedFiles.value.length)
    
    // 标记所有新文件为上传中
    for (let i = 0; i < newFiles.length; i++) {
      uploadingFiles.value.add(startIndex + i)
    }
    
    try {
      // 批量上传所有新选择的文件
      await uploadBatchFiles(newFiles, startIndex)
    } catch (error) {
      console.error('批量上传失败:', error)
      // 上传失败时移除所有新添加的文件
      uploadedFiles.value.splice(startIndex, newFiles.length)
      // 清除上传中标记
      for (let i = 0; i < newFiles.length; i++) {
        uploadingFiles.value.delete(startIndex + i)
      }
    }
    
    // 更新显示的文件名信息
    updateFileNameDisplay()
    
    // 重置输入框，允许重复选择相同文件
    if (input) {
      input.value = ''
    }
  }
}

// 批量上传文件
async function uploadBatchFiles(files: File[], startIndex: number) {
  const formData = new FormData()
  
  // 添加所有文件到FormData
  files.forEach(file => {
    formData.append('files', file)
  })
  
  try {
    console.log(`开始批量上传 ${files.length} 个文件`)
    const response = await filesUpload(formData)
    console.log('批量上传响应:', response)
    
    // 处理上传成功的响应
    const data = response.data || response
    if (data && data.code === 200 && data.urls) {
      // 处理批量上传返回的URLs - urls字段是用逗号拼接的字符串
      let urls: string[] = []
      
      if (typeof data.urls === 'string') {
        // 用逗号分割字符串得到URL数组
        urls = data.urls.split(',').map((url: string) => url.trim()).filter((url: string) => url)
      } else if (Array.isArray(data.urls)) {
        // 如果已经是数组则直接使用
        urls = data.urls.filter((url: any) => url)
      }
      
      console.log('解析后的URLs数组:', urls)
      
      // 确保 uploadedFileUrls 数组有足够的长度并设置URLs
      for (let i = 0; i < files.length; i++) {
        const fileIndex = startIndex + i
        while (uploadedFileUrls.value.length <= fileIndex) {
          uploadedFileUrls.value.push('')
        }
        
        if (urls[i]) {
          uploadedFileUrls.value[fileIndex] = urls[i]
          console.log(`文件 ${files[i].name} 上传成功，URL: ${urls[i]}`)
        } else {
          console.warn(`文件 ${files[i].name} 上传成功但未返回URL`)
        }
      }
    } else {
      throw new Error('批量上传响应格式异常')
    }
  } catch (error) {
    console.error('批量上传失败:', error)
    throw error
  } finally {
    // 移除所有文件的上传中标记
    for (let i = 0; i < files.length; i++) {
      uploadingFiles.value.delete(startIndex + i)
    }
  }
}

// 更新文件名显示
function updateFileNameDisplay() {
  if (uploadedFiles.value.length === 0) {
    fileName.value = ''
  } else if (uploadedFiles.value.length === 1) {
    fileName.value = uploadedFiles.value[0].name
  } else {
    fileName.value = `已选择 ${uploadedFiles.value.length} 个文件`
  }
}

// 新增：删除单个文件的函数
function removeFile(index: number) {
  uploadedFiles.value.splice(index, 1)
  uploadedFileUrls.value.splice(index, 1) // 同时删除对应的URL
  uploadingFiles.value.delete(index) // 移除上传中标记
  
  // 更新后续文件的上传中标记索引
  const newUploadingFiles = new Set<number>()
  uploadingFiles.value.forEach(fileIndex => {
    if (fileIndex > index) {
      newUploadingFiles.add(fileIndex - 1)
    } else if (fileIndex < index) {
      newUploadingFiles.add(fileIndex)
    }
  })
  uploadingFiles.value = newUploadingFiles
  
  updateFileNameDisplay()
}

// 新增：清空所有文件的函数
function clearAllFiles() {
  uploadedFiles.value = []
  uploadedFileUrls.value = []
  uploadingFiles.value.clear()
  fileName.value = ''
  // 重置文件输入框
  if (fileInput.value) {
    fileInput.value.value = ''
  }
}

// 新增：格式化文件大小
function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}

// 新增：处理图片加载错误
function handleImageError(event: Event) {
  const img = event.target as HTMLImageElement
  console.warn('图片加载失败:', img.src)
}

// 标签输入内容
const tagInputs = ref<Record<string, string>>({})

// 标签列表及占位符
const tagList = computed(() => {
  if (descOption.value === 'rebuild') {
    // 重建项目标签
    return [
      { name: 'scene', label: t('releaseTask.scene'), placeholder: t('releaseTask.scenePlaceholder') },
      { name: 'effect', label: t('releaseTask.effect'), placeholder: t('releaseTask.effectPlaceholder') },
      { name: 'requirement', label: t('releaseTask.requirement'), placeholder: t('releaseTask.requirementPlaceholder') },
      { name: 'area', label: t('releaseTask.area'), placeholder: t('releaseTask.areaPlaceholder') },
      { name: 'material', label: t('releaseTask.material'), placeholder: t('releaseTask.materialPlaceholder') },
      { name: 'deadline', label: t('releaseTask.deadline'), placeholder: t('releaseTask.deadlinePlaceholder') }
    ]
  } else if (descOption.value === 'create') {
    // 新建项目标签
    return [
      { name: 'newType', label: t('releaseTask.newType'), placeholder: t('releaseTask.newTypePlaceholder') },
      { name: 'effect', label: t('releaseTask.beffect'), placeholder: t('releaseTask.beffectPlaceholder') },
      { name: 'newArea', label: t('releaseTask.newArea'), placeholder: t('releaseTask.newAreaPlaceholder') },
      { name: 'newMaterial', label: t('releaseTask.newMaterial'), placeholder: t('releaseTask.newMaterialPlaceholder') },
      { name: 'newEstimateTime', label: t('releaseTask.newEstimateTime'), placeholder: t('releaseTask.newEstimateTimePlaceholder') },
    ]
  }
  return []
})

// textarea 替换为 contenteditable
const editableDiv = ref<HTMLDivElement | null>(null)

function toggleTag(tag: string) {
  const idx = selectedTags.value.indexOf(tag)
  if (idx > -1) {
    selectedTags.value.splice(idx, 1)
    delete tagInputs.value[tag]
  } else {
    selectedTags.value.push(tag)
    tagInputs.value[tag] = ''
    // 选中后聚焦到div
    nextTick(() => {
      editableDiv.value?.focus()
    })
  }
}


function handleTagDivInput(tag: string, e: Event) {
  const el = e.target as HTMLElement;
  // 判断内容是否为空或只包含<br>
  if (!el.innerText.trim() && (el.innerHTML === '<br>' || el.innerHTML === '')) {
    el.innerHTML = '';
    tagInputs.value[tag] = '';
  } else {
    tagInputs.value[tag] = el.innerText;
  }
}

// 删除标签
function removeTag(tag: string) {
  toggleTag(tag)
}

// 获取内容（标签+输入+普通文本）
function getDetailDesc() {
  let content = ''
  selectedTags.value.forEach(tag => {
    const tagLabel = tagList.value.find(t => t.name === tag)?.label || tag
    content += `[${tagLabel}:${tagInputs.value[tag] || ''}] `
  })
  // 获取剩余文本
  const text = editableDiv.value?.innerText || ''
  // 去掉标签部分
  const tagReg = /\[.*?:.*?\]\s*/g
  content += text.replace(tagReg, '').trim()
  return content.trim()
}


// Stripe 相关状态，支付一套
const stripe = ref<any>(null);
const elements = ref<any>(null);
const paymentElement = ref<any>(null);
const showStripeForm = ref(false);
const processingPayment = ref(false);
const currentOrderData = ref<any>({});
// 下单 Loading 状态
const placingOrder = ref(false);

// 当支付弹窗出现时，自动关闭下单 Loading
watch(showStripeForm, (val) => {
  if (val) {
    placingOrder.value = false;
  }
});

// 响应式宽度
const isMobile = computed(() => {
  return window.innerWidth < 768; // 768px 是常见的移动端断点
});

const paymentDialogWidth = computed(() => {
  return isMobile.value ? '90%' : '500px';
});

// 初始化 Stripe
const initializeStripe = async () => {
  try {
    // 1. 首先显示支付表单
    showStripeForm.value = true;
    
    // 2. 等待DOM更新
    await nextTick();
    
    // 3. 检查元素是否存在
    if (!document.getElementById('payment-element')) {
      throw new Error('找不到支付元素');
    }

    // 4. 初始化Stripe
    stripe.value = await loadStripe('pk_live_51RvLC10yBbS4PY4j3JKyxhB5GVtvnGv7jcziSrleIFGwNtXezatYKI6l5xfmFC944XpTKWFECiTbTLLlDWJ4iHfA00DOtB0qrR');
    if (!stripe.value) {
      throw new Error('Stripe初始化失败');
    }
    // 5. 创建Elements实例
    elements.value = stripe.value.elements({
      clientSecret: currentOrderData.value.clientSecret,
      appearance: {
        theme: 'stripe',
        variables: {
          colorPrimary: '#409EFF',
          colorBackground: '#ffffff',
          colorText: '#303133',
          fontFamily: 'Arial, sans-serif',
        }
      }
    });
    
    // 6. 创建并挂载支付元素
    paymentElement.value = elements.value.create('payment');
    await paymentElement.value.mount('#payment-element');
    
  } catch (error) {
    console.error('Stripe初始化失败:', error);
    ElMessage.error('支付初始化失败');
    showStripeForm.value = false; // 出错时隐藏表单
  }
};
const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
// 处理支付提交
const handlePaymentSubmit = async () => {
  if (!stripe.value || !elements.value) {
    ElMessage.error('支付未初始化');
    return;
  }

  processingPayment.value = true;
  
  try {
    // 这里需要从后端获取 clientSecret
    const { error } = await stripe.value.confirmPayment({
      elements: elements.value,
      confirmParams: {
        return_url: `${window.location.origin}/order-success`,
        // 可以在这里传递订单信息
        receipt_email: userInfo.email || '',
      },
      redirect: 'if_required'
    });

    if (error) {
      throw error;
    }
    
    // 支付成功处理
    step.value++;
    showStripeForm.value = false;
    
    
  } catch (error: any) {
    console.error('Payment error:', error);
    const message = error.message || '支付失败';
    const errorElement = document.getElementById('payment-message');
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
    }
  } finally {
    processingPayment.value = false;
  }
};

// 取消支付
const cancelPayment = () => {
  showStripeForm.value = false;
  if (paymentElement.value) {
    paymentElement.value.destroy();
    paymentElement.value = null;
  }
};

// 在组件卸载时清理
onUnmounted(() => {
  if (paymentElement.value) {
    paymentElement.value.destroy();
  }
});

const placeOrder = async () => {
  try {
    placingOrder.value = true;
    // 将选中的标签和对应的输入内容组织成对象
const tagData: Record<string, string> = {}
selectedTags.value.forEach(tag => {
  tagData[tag] = tagInputs.value[tag] || ''
})

// 获取当前时间作为招标开始时间
const now = new Date()
const biddingStartTime = now.toISOString().slice(0, 19).replace('T', ' ') // 格式化为 YYYY-MM-DD HH:mm:ss

// 格式化截止时间为 YYYY-MM-DD HH:mm:ss 格式
const formattedBidDeadline = bidDeadline.value ? bidDeadline.value.replace('T', ' ') + ':00' : ''
const parms = {
  projectType: descOption.value, // 'rebuild' 或 'create'
  shortDesc: shortDesc.value,
  detailDesc: detailDesc.value,
  tags: selectedTags.value, // 选择的标签数组（英文key）
  tagInputs: tagData, // 标签输入内容对象
  attachmentUrls: uploadedFileUrls.value.filter(url => url), // 文件URL数组
  budget: budget.value,
  biddingStartTime: biddingStartTime, // 招标开始时间（当前时间）
  biddingEndTime: formattedBidDeadline, // 招标截止时间
  contactPhone: phone.value,
  contactPerson: publisher.value
}

    const res: any = await createTender(parms)
    step.value = 2;
    if (res.code === 200) {
      currentOrderData.value = res.data;
      console.log(res.data)
      await initializeStripe();
    } else {
      ElMessage.error(t('releaseTask.payFail'));
    }
  } catch (error) {
    ElMessage.error(t('releaseTask.payFail'));
  } finally {
    // 若未弹出支付窗，则关闭loading；若已弹出，watcher会关闭
    if (!showStripeForm.value) {
      placingOrder.value = false;
    }
  }
};

// 提交时获取内容
async function nextStep() {


  if (step.value === 1) {
    if (!descOption.value) {
      window.alert(t('releaseTask.validateDescOption') || '请选择重建或新建');
      return;
    }
    if (!String(shortDesc.value || '').trim()) {
      window.alert(t('releaseTask.validateShortDesc'));
      return;
    }
    for (const tag of selectedTags.value) {
      if (!tagInputs.value[tag] || !String(tagInputs.value[tag] || '').trim()) {
        window.alert(t('releaseTask.validateTag', { tag }));
        return;
      }
    }
    // 获取全部内容
    const desc = getDetailDesc()
    if (desc.length < 10) {
      window.alert(t('releaseTask.validateDetailDesc'));
      return;
    }
  }
  if (step.value === 2) {
    if (!budget.value || Number(budget.value) <= 0) {
      window.alert(t('releaseTask.validateBudget'));
      return;
    }
    if (!String(bidDeadline.value || '').trim()) {
      window.alert(t('releaseTask.validateBidDeadline'));
      return;
    }
    // 验证截止时间必须是未来时间
    const deadlineDate = new Date(bidDeadline.value);
    const currentDate = new Date();
    if (deadlineDate <= currentDate) {
      window.alert(t('releaseTask.validateBidDeadlineFuture'));
      return;
    }
    if (!String(phone.value || '').trim()) {
      window.alert(t('releaseTask.validatePhone'));
      return;
    }
    if (!String(publisher.value || '').trim()) {
      window.alert(t('releaseTask.validatePublisher'));
      return;
    }
    // 直接显示确认对话框，不需要验证码
    // showConfirm.value = true;
    // return;
    // confirmInfo()
  }
  if (step.value === 3) {
    await placeOrder()
  }
  if (step.value < 4) step.value++;

}

function confirmInfo() {
  showConfirm.value = false;
  // if (step.value < 3) step.value++;
// 提交接口

 RequestCreateTender()


}

async function RequestCreateTender() {
  
// 将选中的标签和对应的输入内容组织成对象
const tagData: Record<string, string> = {}
selectedTags.value.forEach(tag => {
  tagData[tag] = tagInputs.value[tag] || ''
})

// 获取当前时间作为招标开始时间
const now = new Date()
const biddingStartTime = now.toISOString().slice(0, 19).replace('T', ' ') // 格式化为 YYYY-MM-DD HH:mm:ss

// 格式化截止时间为 YYYY-MM-DD HH:mm:ss 格式
const formattedBidDeadline = bidDeadline.value ? bidDeadline.value.replace('T', ' ') + ':00' : ''

const parms = {
  projectType: descOption.value, // 'rebuild' 或 'create'
  shortDesc: shortDesc.value,
  detailDesc: detailDesc.value,
  tags: selectedTags.value, // 选择的标签数组（英文key）
  tagInputs: tagData, // 标签输入内容对象
  attachmentUrls: uploadedFileUrls.value.filter(url => url), // 文件URL数组
  budget: budget.value,
  biddingStartTime: biddingStartTime, // 招标开始时间（当前时间）
  biddingEndTime: formattedBidDeadline, // 招标截止时间
  contactPhone: phone.value,
  contactPerson: publisher.value
}
      console.log('招标请求参数：', JSON.stringify(parms, null, 2))
      console.log('选择的标签数组：', selectedTags.value)
      console.log('标签输入数据对象：', tagData)
      console.log('文件URL列表：', uploadedFileUrls.value)
      
      // 开始请求，显示 loading
      isLoading.value = true
      
      try {
        const response = await createTender(parms)

        if (response.code !== 200) {
          ElMessage.error( t('tender.errorMessage'))
         
        }else{
          // 成功，显示成功消息并关闭弹窗
           ElMessage.success(t('tender.successMessage'))
           showConfirm.value = false;
           // 直接关闭弹窗
           resetForm()
           emit('close')
           // 跳转到招标列表页面并刷新
          //  router.push('/tender-list').then(() => {
          //    // 强制刷新页面
          //    window.location.reload()
          //  })
        }
        console.log('招标创建响应：', response)
      } catch (error) {
        console.error('招标创建失败：', error)
        window.alert('创建失败，请稍后重试')
      } finally {
        // 请求完成，取消 loading
        isLoading.value = false
      }
}

function cancelConfirm() {
  showConfirm.value = false;
}
function prevStep() {
  if (step.value > 1) step.value--
}

// 重置表单
function resetForm() {
  step.value = 1
  shortDesc.value = ''
  detailDesc.value = ''
  fileName.value = ''
  uploadedFiles.value = [] // 清空上传的文件
  uploadedFileUrls.value = [] // 清空文件URL
  uploadingFiles.value.clear() // 清空上传中标记
  budget.value = 0
  bidDeadline.value = getDefaultDeadline() // 重置截止时间为默认值
  phone.value = ''
  publisher.value = ''
  showConfirm.value = false
  isLoading.value = false
  selectedTags.value = []
  descOption.value = ''
  Object.keys(tagInputs.value).forEach(key => tagInputs.value[key] = '')
  nextTick(() => {
    if (editableDiv.value) editableDiv.value.innerHTML = ''
    // 重置文件输入框
    if (fileInput.value) {
      fileInput.value.value = ''
    }
  })
}

function handleClose() {
  // 如果在第三步（完成步骤），跳转到招标列表页面
  if (step.value === 4) {
    resetForm()
    emit('close')
    // 跳转到招标列表页面并刷新
    router.push('/tender-list').then(() => {
      // 强制刷新页面
      window.location.reload()
    })
  } else {
    resetForm()
    emit('close')
  }
}

// 监听 descOption 变化，重置相关字段
watch(descOption, () => {
  selectedTags.value = []
  Object.keys(tagInputs.value).forEach(key => tagInputs.value[key] = '')
  detailDesc.value = ''
  nextTick(() => {
    if (editableDiv.value) editableDiv.value.innerHTML = ''
  })
})
</script>

<style scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1;
  transition: background 0.3s;
}

.release-task-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  width: 900px;
  max-width: 98vw;
  max-height: 95vh; /* 添加最大高度限制 */
  min-height: 600px;
  border-radius: 14px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
  z-index: 1;
  padding: 0;
  font-family: inherit;
  transition: box-shadow 0.3s;
  overflow: hidden; /* 隐藏超出部分 */
  display: flex;
  flex-direction: column; /* 垂直布局以便内容可滚动 */
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  border-radius: 14px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #fb6e01;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.dialog-main {
  display: flex;
  flex-direction: row;
  min-height: 600px;
  flex: 1; /* 占满剩余空间 */
  overflow: hidden; /* 隐藏超出部分 */
}

.dialog-left {
  width: 340px;
  background: #fafafa;
  border-radius: 14px 0 0 14px;
  padding: 0 36px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* 垂直居中内容 */
  border-right: 1px solid #f0f0f0;
  min-height: 600px;
  position: relative;
}

.dialog-header {
  width: 100%;
  padding: 0;
  margin-bottom: 0;
  /* 去掉底部间距 */
  position: absolute;
  top: 36px;
  left: 36px;
  right: 36px;
}

.progress-bar {
  position: relative;
  width: 80%;
  /* 改为80%，不会超出左侧区域 */
  min-width: 180px;
  /* 可选，防止太短 */
  max-width: 260px;
  /* 可选，防止太长 */
  height: 22px;
  background: #f5f5f5;
  border-radius: 11px;
  margin-bottom: 38px;
  margin-left: 0;
  padding: 0;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.progress {
  position: absolute;
  top: 50%;
  left: 0;
  height: 5px;
  width: 100%;
  border-radius: 3px;
  transform: translateY(-50%);
  z-index: 1;
}

.progress-line {
  position: absolute;
  top: 50%;
  left: 0;
  height: 5px;
  background-color: #b3aeae;
  width: 100%;
  border-radius: 3px;
  transform: translateY(-50%);
  z-index: 1;
}

.progress[style] {
  background: #fb6e01;
  z-index: 2;
}

.progress-dot {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  /* 更小 */
  height: 14px;
  background: #fff;
  border: 2px solid #bbb;
  /* 更细 */
  border-radius: 50%;
  z-index: 3;
  transition: border-color 0.3s, background 0.3s;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-dot.active {
  border-color: #fb6e01;
  background: #fb6e01;
}

.progress-dot::after {
  content: '';
  display: block;
  width: 6px;
  /* 更小 */
  height: 6px;
  background: #fff;
  border-radius: 50%;
  margin: auto;
}

.progress-label {
  position: absolute;
  top: 18px;
  /* 圆点下方 */
  transform: translateX(-50%);
  font-size: 13px;
  color: #888;
  white-space: nowrap;
  pointer-events: none;
  font-weight: 500;
}

.progress-tip {
  color: #888;
  font-size: 15px;
  margin-top: 18px;
  line-height: 1.8;
}

.dialog-right {
  flex: 1;
  position: relative;
  padding: 40px 40px 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden; /* 隐藏超出部分，为内部滚动做准备 */
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 32px;
  color: #888;
  cursor: pointer;
  z-index: 10;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #fb6e01;
}

.dialog-body {
  padding: 0;
  flex: 1; /* 占满可用空间 */
  overflow-y: auto; /* 添加垂直滚动 */
  overflow-x: hidden; /* 隐藏水平滚动 */
  padding-right: 8px; /* 为滚动条留出空间 */
}

.desc-short {
  margin-bottom: 14px;
}

.desc-short input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 15px;
}

.desc-type-tip {
  color: #f00;
  font-size: 14px;
  font-weight: normal;
  white-space: nowrap;
}

.desc-radio-group {
  display: flex;
  gap: 24px;
  margin-bottom: 12px;
  align-items: center;
}

.desc-radio {
  font-size: 15px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.desc-radio input[type="radio"] {
  accent-color: #fb6e01;
  width: 16px;
  height: 16px;
}

.tag-section {
  margin-bottom: 14px;
  max-height: 150px; /* 固定最大高度 */
  overflow-y: auto; /* 超出时显示垂直滚动条 */
}

.tag-group {
  display: flex;
  align-items: flex-start; /* 改为顶部对齐 */
  margin-bottom: 8px;
  flex-wrap: nowrap; /* 保持不换行 */
}

.tag-label {
  min-width: 90px;
  color: #666;
  font-size: 14px;
}

.tags {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  /* 标签间距更小 */
  max-height: 120px; /* 标签容器固定高度 */
  overflow-y: auto; /* 超出时显示滚动条 */
  padding-right: 8px; /* 为滚动条留出空间 */
}

.tag {
  display: inline-block;
  padding: 4px 9px;
  /* 内边距更小 */
  border-radius: 14px;
  background: #f5f5f5;
  color: #666;
  font-size: 13px;
  /* 字体更小 */
  cursor: pointer;
  border: 1px solid #eee;
  transition: all 0.2s;
  margin-left: 6px;
  /* 标签间距更小 */
}

.tag.selected {
  background: #fb6e01;
  color: #fff;
  border: 1px solid #fb6e01;
}

/* 自定义滚动条样式 */
.tag-section::-webkit-scrollbar,
.tags::-webkit-scrollbar {
  width: 6px;
}

.tag-section::-webkit-scrollbar-track,
.tags::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.tag-section::-webkit-scrollbar-thumb,
.tags::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.tag-section::-webkit-scrollbar-thumb:hover,
.tags::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* 弹窗内容区域滚动条样式 */
.dialog-body::-webkit-scrollbar {
  width: 8px;
}

.dialog-body::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.desc-detail {
  margin-bottom: 14px;
}

.desc-detail textarea {
  width: 100%;
  min-height: 80px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 15px;
  resize: vertical;
}

.upload-section {
  display: flex;
  flex-direction: column;     /* 改为纵向排列 */
  gap: 12px;
  margin-bottom: 10px;
}

.upload-btn {
  background: #fb6e01;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 7px 18px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
  align-self: flex-start;     /* 按钮左对齐 */
}

.upload-btn:hover {
  background: #e05602;
}

.upload-tip {
  margin-top: -2px;
  font-size: 13px;
  color: #909399;
  text-align: left;
  line-height: 1.4;
}

.uploaded-files {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
}

.files-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

.files-count {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.clear-all-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.clear-all-btn:hover {
  background: #c82333;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  gap: 12px;
}

.file-preview {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  flex-shrink: 0;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f1f3f4;
}

.preview-icon {
  font-size: 24px;
  opacity: 0.6;
}

.file-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.file-name {
  flex: 1;
  font-size: 14px;
  color: #495057;
  margin-right: 8px;
  word-break: break-all;
}

.file-size {
  font-size: 12px;
  color: #6c757d;
}

.upload-status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 3px;
  margin-right: 8px;
  white-space: nowrap;
}

.upload-status.uploading {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.upload-status.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.upload-status.failed {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.remove-file-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.remove-file-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.remove-file-btn:hover:not(:disabled) {
  background: #c82333;
}

.dialog-footer {
  padding: 16px 0 24px 0;
  text-align: right;
  flex-shrink: 0; /* 防止被压缩 */
  border-top: 1px solid #f0f0f0; /* 添加顶部边框以区分内容 */
  background: #fff; /* 确保背景色 */
}

.prev-btn {
  background: #fff;
  color: #fb6e01;
  border: 1px solid #fb6e01;
  border-radius: 4px;
  padding: 10px 28px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 16px;
  transition: background 0.2s, color 0.2s;
}

.prev-btn:disabled {
  color: #ccc;
  border-color: #eee;
  cursor: not-allowed;
  background: #fafafa;
}

.next-btn {
  background: #fb6e01;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 28px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}

.next-btn:hover {
  background: #e05602;
}

.budget-section,
.deadline-section,
.phone-section,
.publisher-section {
  margin-bottom: 18px;
}

.budget-section label,
.deadline-section label,
.phone-section label,
.publisher-section label {
  font-size: 15px;
  color: #333;
  display: block;
  margin-bottom: 6px;
}

.required {
  color: #f00;
  margin-left: 2px;
  font-size: 16px;
  vertical-align: middle;
}

.budget-section input,
.deadline-section input,
.phone-section input,
.publisher-section input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 15px;
  margin-top: 2px;
}

.confirm-mask {
  position: fixed;
  z-index: 4000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-dialog {
  background: #fff;
  border-radius: 8px;
  padding: 32px 28px 18px 28px;
  min-width: 300px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  text-align: center;
  margin-top: 80px;
}

.confirm-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 18px;
}

.confirm-content {
  font-size: 16px;
  margin-bottom: 22px;
  color: #333;
}

.confirm-actions {
  display: flex;
  justify-content: center;
  gap: 28px;
}

.confirm-cancel,
.confirm-ok {
  padding: 7px 28px;
  border-radius: 4px;
  font-size: 15px;
  border: none;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
}

.confirm-cancel {
  background: #eee;
  color: #666;
}

.confirm-ok {
  background: #fb6e01;
  color: #fff;
}

.confirm-ok:hover:not(:disabled) {
  background: #e05602;
}

.confirm-cancel:disabled,
.confirm-ok:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-tip {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  margin: 60px 0;
}

.publish-summary {
  background: #fafafa;
  border-radius: 8px;
  padding: 18px 20px;
  margin: 24px 0 0 0;
  font-size: 15px;
  color: #333;
  line-height: 1.8;
}

.summary-title {
  font-weight: bold;
  font-size: 17px;
  margin-bottom: 10px;
  color: #fb6e01;
}

.summary-item {
  margin-bottom: 6px;
}

.editable-desc:empty:before {
  content: attr(placeholder);
  color: #bbb;
  pointer-events: none;
}

.tag-in-desc input {
  background: transparent;
  border: none;
  color: black;
  outline: none;
  width: 90px;
}

.editable-desc {
  min-height: 80px;
  width: 100%;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  font-size: 15px;
  /* 关键：纵向排列每个标签块 */
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* 允许内容自动换行 */
  white-space: normal;
  word-break: break-all;
}

.tag-in-desc {
  display: flex;
  align-items: flex-start;
  /* 保证顶部对齐 */
  background: none !important;
  color: #222 !important;
  border-radius: 0;
  padding: 2px 0;
  margin-bottom: 0;
  margin-right: 0;
  gap: 4px;
}

.tag-input-div {
  flex: 1 1 0%;
  min-width: 0;
  max-width: 100%;
  display: block;
  word-break: break-all;
  white-space: pre-wrap;
  background: transparent;
  outline: none;
  border: none;
  padding: 0 4px;
  margin: 0 4px;
}

.remove-btn {
  color: #f00;
  cursor: pointer;
  margin-left: 4px;
  user-select: none;
}

.custom-textarea:empty:before {
  content: attr(placeholder);
  color: #bbb;
  pointer-events: none;
  display: block;
  font-size: 14px;
}

/* 富文本编辑器样式 */
.rich-text-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;
}

.rich-text-toolbar {
  background: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
  padding: 8px;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.toolbar-btn {
  padding: 4px 8px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  color: #606266;
  transition: all 0.2s;
}

.toolbar-btn:hover {
  background: #f0f0f0;
  border-color: #409eff;
  color: #409eff;
}

.toolbar-btn.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.rich-text-content {
  height: 200px;
  overflow-y: auto;
  padding: 12px;
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
  outline: none;
  border: none;
  resize: none;
  word-break: break-word;
  flex: 1;
}

.rich-text-content:empty:before {
  content: attr(placeholder);
  color: #c0c4cc;
  pointer-events: none;
  font-style: italic;
}

.rich-text-content ul,
.rich-text-content ol {
  margin: 8px 0;
  padding-left: 20px;
}

.rich-text-content li {
  margin: 4px 0;
}

.rich-text-content p {
  margin: 8px 0;
}

.rich-text-content strong {
  font-weight: bold;
}

.rich-text-content em {
  font-style: italic;
}

.rich-text-content u {
  text-decoration: underline;
}

.tag-input-div:empty:before {
  content: attr(placeholder);
  color: #bbb;
  pointer-events: none;
  display: inline-block;
  font-size: 14px;
}

@media (max-width: 600px) {
  .tag-input-div:empty:before {
    font-size: 13px;
  }
}

@media (max-width: 600px) {
  .release-task-dialog {
    width: 100vw;
    min-width: 0;
    max-width: 100vw;
    max-height: 100vh; /* 限制最大高度为视口高度 */
    height: 100vh; /* 固定高度避免内容溢出 */
    min-height: 100vh;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    /* 保持原有的居中定位方式 */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
  }

  .dialog-main {
    flex-direction: column;
    min-height: 100vh;
    max-height: 100vh; /* 限制最大高度 */
    height: 100vh; /* 固定高度为视口高度 */
    overflow: hidden; /* 隐藏超出部分 */
    display: flex; /* 确保为flex容器 */
  }

  .dialog-left {
    width: 100%;
    min-height: auto;
    border-radius: 0;
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
    padding: 38px 10px 10px 10px;
    /* 只保留上下padding，去掉左右 */
    position: static;
  }

  .dialog-header {
    position: static;
    padding: 0 20px 0 25px;
    margin-bottom: 10px;
    left: 0;
    right: 0;
    top: 0;
  }

  .progress-bar {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    margin-bottom: 18px;
  }

  .progress-label {
    font-size: 12px;
    top: 20px;
  }

  .progress-tip-center {
    font-size: 14px;
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
    word-break: break-all;
    white-space: normal;
    padding: 0 10px;
    /* 只在这里加左右padding，防止内容贴边 */
  }

  .dialog-right {
    padding: 18px 10px 59px 10px;
    flex: 1; /* 占满可用空间 */
    overflow: hidden; /* 隐藏超出部分 */
    display: flex;
    flex-direction: column;
    min-height: 0; /* 确保flex子元素可以收缩 */
  }

  .dialog-body {
    flex: 1; /* 占满可用空间 */
    overflow-y: auto; /* 允许垂直滚动 */
    overflow-x: hidden; /* 隐藏水平滚动 */
    padding-right: 5px; /* 为滚动条留出更小的空间 */
    padding-bottom: 20px; /* 为底部按钮区域留出空间 */
    min-height: 0; /* 确保flex子元素可以收缩 */
  }

  .desc-short input,
  .budget-section input,
  .deadline-section input,
  .phone-section input,
  .publisher-section input {
    font-size: 14px;
    padding: 8px 6px;
  }

  .desc-detail {
    margin-bottom: 10px;
  }

  .editable-desc {
    font-size: 14px;
    padding: 8px;
    min-height: 60px;
  }

  .tag-in-desc {
    font-size: 13px;
    gap: 2px;
  }

  .tag-input-div {
    min-width: 80px;
    max-width: 100%;
    font-size: 13px;
    padding: 0 2px;
  }

  .tags {
    gap: 4px;
    max-height: 80px; /* 移动端更小的高度限制 */
    overflow-y: auto; /* 超出时显示滚动条 */
  }

  .tag {
    font-size: 12px;
    padding: 3px 7px;
    margin-left: 4px;
  }

  .upload-section {
    gap: 8px;
    margin-bottom: 8px;
  }

  .upload-btn {
    font-size: 14px;
    padding: 6px 12px;
  }

  .uploaded-files {
    padding: 8px;
  }

  .files-header {
    margin-bottom: 6px;
    padding-bottom: 6px;
  }

  .files-count {
    font-size: 13px;
  }

  .clear-all-btn {
    padding: 3px 8px;
    font-size: 11px;
  }

  .file-item {
    padding: 6px 8px;
    gap: 8px;
  }

  .file-preview {
    width: 50px;
    height: 50px;
  }

  .preview-icon {
    font-size: 20px;
  }

  .file-info {
    gap: 2px;
  }

  .file-name {
    font-size: 13px;
  }

  .file-size {
    font-size: 11px;
  }

  .upload-status {
    font-size: 10px;
    padding: 1px 4px;
    margin-right: 4px;
  }

  .remove-file-btn {
    width: 18px;
    height: 18px;
    font-size: 12px;
  }

  .dialog-footer {
    padding: 12px 10px 20px 10px;
    flex-shrink: 0; /* 防止被压缩 */
    border-top: 1px solid #f0f0f0; /* 添加顶部边框 */
    background: #fff; /* 确保背景色 */
    position: sticky; /* 粘性定位 */
    bottom: 0; /* 贴底显示 */
    z-index: 10; /* 确保在最上层 */
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1); /* 添加上阴影 */
  }

  .prev-btn,
  .next-btn {
    font-size: 14px;
    padding: 10px 20px;
    margin-right: 8px;
    min-height: 44px; /* iOS推荐的最小触摸区域 */
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .success-tip {
    font-size: 18px;
    margin: 30px 0 10px 0;
    text-align: right !important;
  }

  .publish-summary {
    font-size: 13px;
    padding: 12px 8px;
    margin: 16px 0 0 0;
  }

  .summary-title {
    font-size: 15px;
    margin-bottom: 6px;
  }

  .editable-desc:empty:before,
  .custom-textarea:empty:before {
    content: attr(placeholder);
    color: #bbb;
    pointer-events: none;
    display: block;
    font-size: 14px;
  }

  /* 移动端滚动条样式 */
  .dialog-body::-webkit-scrollbar {
    width: 4px; /* 移动端更细的滚动条 */
  }

  .dialog-body::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 2px;
  }

  .dialog-body::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }

  .dialog-body::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
}

@media (max-width: 600px) {
  .progress-tip-center {
    word-break: break-all;
    white-space: normal;
    padding: 0 10px;
    box-sizing: border-box;
    text-align: left !important;
    font-size: 14px;
    max-width: 100vw;
    margin-bottom: 10px;
  }

  .success-tip {
    word-break: break-all;
    white-space: normal;
    padding: 0 10px;
    box-sizing: border-box;
    text-align: right !important;
    font-size: 18px;
    max-width: 100vw;
    margin: 30px 0;
  }

  /* 针对大标题，手机端缩小字体并去掉大margin */
  .progress-tip-center>div>div[style*="font-size:26px"] {
    font-size: 17px !important;
    margin-bottom: 6px !important;
    text-align: left !important;
    word-break: break-all;
  }

  /* 确保按钮在小屏幕设备上也能正常显示 */
  @media (max-height: 600px) {
    .dialog-left {
      padding: 20px 10px 8px 10px;
    }
    
    .progress-tip-center {
      margin-bottom: 8px;
    }
    
    .progress-tip-center > div > div:first-child {
      font-size: 16px !important;
      margin-bottom: 4px !important;
    }
  }

  /* 针对iPhone SE等小屏设备的特殊适配 */
  @media (max-height: 568px) {
    .dialog-left {
      padding: 15px 10px 5px 10px;
    }
    
    .progress-bar {
      margin-bottom: 10px;
    }
    
    .progress-tip-center {
      font-size: 13px;
      margin-bottom: 5px;
    }
  }
}
</style>